import browser from './browser';
import { hasTouch, isMobile } from './constants';
/* import Lenis from 'lenis'; */
import { Fancybox } from "@fancyapps/ui";

/**
 * After Load
 *
 * @file loadPage.js
 */
const loadPage = (() => {
  const documentHtml = document.getElementsByTagName('html')[0];
  const browserName = browser.getDetail().name.toLowerCase() || '';
  const browserVersion = browser.getDetail().version || '';

  const classes = [];


  /**
   * JS Load Class
   * js load class for css
   */
  const htmlAddedClasses = () => {
    classes.push('no-js');
    if (hasTouch) {
      classes.push('touch');
    } else {
      classes.push('no-touch');
    }

    if (isMobile) {
      classes.push('mobile');
    } else {
      classes.push('desktop');
    }
    classes.push(browserName.replace(/ /g, '-'));
    classes.push(browserVersion);
    classes.push('js');
    classes.shift();
    documentHtml.className = classes.join(' ');
  };

  const lazyLoadP = () =>{
    document.addEventListener('DOMContentLoaded', function () {
      const lazyImages = document.querySelectorAll('.lazy');
    
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove('lazy');
            observer.unobserve(image);
          }
        });
      });
    
      lazyImages.forEach(image => {
        observer.observe(image);
      });
    });
  }

  const pageloadScroll = () =>{
    document.addEventListener('DOMContentLoaded', function () {
      /*
      const scrollableDivs = document.querySelectorAll('.overflow-auto, .fancybox__carousel, .fancybox__content, .payment-modal');
      const allElements = document.querySelectorAll('*');
      const scrollPreventSelectors = 'form, input, textarea, select, [contenteditable="true"]';
      scrollableDivs.forEach(scrollableDiv => { scrollableDiv.setAttribute("data-lenis-prevent", "true"); });
      document.querySelectorAll(scrollPreventSelectors).forEach(el => { el.setAttribute("data-lenis-prevent", "true"); });
      allElements.forEach(element => {
        const style = window.getComputedStyle(element);
        if (style.overflow === 'auto') element.setAttribute("data-lenis-prevent", "true");
      });
      */
      Fancybox.bind("[data-fancybox]");
    });

  
    const buttonModalToggle = () => {
  
      let modalStack = [];
  
      function openModal(modalId) {
        const modal = document.querySelector(`[data-id="${modalId}"]`);
        if (modal) {
          
          if (modalStack.length > 0) {
            const previousModal = modalStack[modalStack.length - 1];
            previousModal.style.display = 'none';
          }
  
          modal.classList.add('modal-open');
          modal.classList.remove('modal-close');
          modal.style.display = 'block';
          modalStack.push(modal); 
  
          if (modalStack.length === 1) {
            document.body.classList.add("overflow-hidden");
          }
        }
      }
  
      
      function closeModal(modalId) {
        const modal = document.querySelector(`[data-id="${modalId}"]`);
        if (modal) {
          modal.classList.add('modal-close');
          modal.classList.remove('modal-open');
          modal.style.display = 'none';
          modalStack.pop(); 
  
          
          if (modalStack.length > 0) {
            const previousModal = modalStack[modalStack.length - 1];
            previousModal.style.display = 'block';
          } else {
            document.body.classList.remove("overflow-hidden");
          }
        }
      }
  
      document.querySelectorAll('[data-toogle-s-modal]').forEach(button => {
        button.addEventListener('click', function() {
          const modalId = this.getAttribute('data-toogle-s-modal');
          openModal(modalId);
        });
      });
  
      document.querySelectorAll('.modal-close').forEach(button => {
        button.addEventListener('click', function() {
          const modal = this.closest('.payment-modal');
          if (modal) {
            closeModal(modal.getAttribute('data-id'));
          }
        });
      });
  
      document.addEventListener('click', function(event) {
        if (event.target.matches('.modal-backdrop')) {
          const modal = event.target.closest('.payment-modal');
          if (modal) {
            closeModal(modal.getAttribute('data-id'));
          }
        }
      });
    };
  
    const modalMobileRemoveEdit = () => {
      // $(".ad-more").on('click', function(event) {
      //   $(this).find(".more-pop").toggleClass("active");
      // });
      document.querySelectorAll('.ad-more').forEach(function(element) {
        element.addEventListener('click', function(event) {
          const screenWidth = window.innerWidth;
          event.stopPropagation(); 
          event.preventDefault(); 
          const clickedMorePop = this.querySelector('.more-pop');
          document.querySelectorAll('.ad-more').forEach(otherElement => {
              if (otherElement !== this) {
                  const otherMorePop = otherElement.querySelector('.more-pop');
                  if (otherMorePop) {
                      otherMorePop.classList.remove('active');
                  }
              }
          });
  
          if (clickedMorePop) {
              clickedMorePop.classList.toggle('active');
          }
        });
      });
    };

    /*
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: true,
      triggerRootMargin: '-1px -1px -1px -1px',
      scrollCallback: (scrollData) => {},
    });
    function animate(time) {
      lenis.raf(time);
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
    const formScrollStopSelector = 'form, input, textarea, select';
    document.querySelectorAll(formScrollStopSelector).forEach((el) => {
      el.addEventListener('mouseenter', () => lenis.stop());
      el.addEventListener('mouseleave', (e) => {
        const to = e.relatedTarget;
        if (!to || !to.closest || !to.closest('form')) lenis.start();
      });
    });
    */

    buttonModalToggle();
    modalMobileRemoveEdit();
    
  }


  const init = () => {
    htmlAddedClasses();
    lazyLoadP();
    pageloadScroll();
  };


  return {
    init,
  };
})();

export default loadPage;
